/**
 * Created by wangjunfei on 2022/2/14.
 */

import React from 'react';
import {Input,Button,Modal,Form,Select,message} from 'antd';
import Table from 'components/Table';
import abortAjaxHoc from 'components/abortAjaxHoc';
const { Search } = Input;
const { Option } = Select;
class BindApikey extends React.Component {
    constructor(props){
        super(props);
        this.columns = [
            {
                title: 'Sub-account',
                dataIndex: 'sub_account_name',
                key: 'sub_account_name',
                width: 300
            }, {
                title: 'AppKey',
                dataIndex: 'api_key',
                key: 'api_key'
            }, {
                title: 'Action',
                dataIndex: 'id',
                key: 'id_control',
                width: 100,
                render: (id)=>{
                    return <a onClick={this.onDelete.bind(this,id)} >Delete</a>;
                }
            }
        ];
    }
    state = {
        loading:false,
        isShowCreate:false,
        searchText:'',
        list:[],
        keyList:[],
        subList:[],
        total:0
    }

    onDelete = (id)=>{
        Modal.confirm({
            title:'Confirm deletion?',
            onOk:()=>{
                return this.props.abortableAjax('DELETE',`/sub_accounts/api_key_assoc/${id}`).then(()=>{
                    message.success('Deleted');
                    this.table.resetChange();
                });
            }
        });
    }

    onSearch = ()=>{
        this.table.resetChange();
    }



    onStart = (params)=>{
        const _params = {};
        _params.page_size = params.limit;
        _params.page_number = params.current;
        _params.q = this.state.searchText;
        return this.props.abortableAjax('GET','/sub_accounts/api_key_assocs',_params).then(res=>{
            const data = res.data;
            this.setState({list:data.data,total:data.total_count});
        });
    }

    onCreate = ()=>{
        if(this.state.keyList.length === 0 || this.state.subList.length===0){
            this.setState({loading:true});
            const keyP = this.props.abortableAjax('GET','/accounts/my/apikeys');
            const subP = this.props.abortableAjax('GET','/auth/sub-accounts');
            Promise.all([keyP,subP]).then((ress)=>{
                this.setState({keyList:ress[0].data,subList:ress[1].data,loading:false,isShowCreate:true});
            });
        }else{
            this.setState({isShowCreate:true});
        }

    }

    onSearchChanage = (event)=>{
        this.setState({searchText:event.target.value});
    }

    createBind = ()=>{

        this.props.form.validateFields((error,value)=>{
            if(!error){
                this.setState({loading:true});
                this.props.abortableAjax('POST','/sub_accounts/api_key_assocs',value).then(()=>{
                    this.table.resetChange();
                    this.setState({isShowCreate:false,loading:false});
                    Modal.success({
                        title:'Created Successfully'
                    });
                }).catch(()=>{
                    this.setState({loading:false});
                });
            }
        });

    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div className='message-list' style={{paddingTop:20}}>
                <div>
                    <Button
                        onClick={this.onCreate}
                        loading={this.state.loading}
                        type='primary'
                    >Create Association</Button>
                    <div style={{marginTop:20,marginBottom:20}}>
                        <Search
                            style={{width:400}}
                            value={this.state.searchText}
                            placeholder="Search sub-account or AppKey"
                            onChange={this.onSearchChanage}
                            onSearch={this.onSearch}
                            enterButton={true}
                        />
                    </div>

                </div>
                <Table
                    autoLoad
                    scroll={{ x: 940 }}
                    ref={(ref)=>{this.table=ref;}}
                    pageSize = {20}
                    rowKey = 'id'
                    dataSource={this.state.list}
                    columns={this.columns}
                    onSubmit={this.onStart}
                    total={this.state.total}
                />
                <Modal
                    visible={this.state.isShowCreate}
                    afterClose={()=>{this.props.form.resetFields();}}
                    onCancel={()=>{this.setState({isShowCreate:false});}}
                    confirmLoading={this.state.loading}
                    onOk={this.createBind}
                >
                    <Form>
                        <Form.Item label="Sub-account">
                            {getFieldDecorator('sub_account_id',{
                                rules:[
                                    {required:true,message:'Required'}
                                ]
                            })(
                                <Select
                                    showSearch
                                    style={{ width: 300 }}
                                    placeholder="Select sub-account"
                                    optionFilterProp="children"
                                >
                                    {this.state.subList.map(item=>{
                                        return <Option key={item.id}>{item.name}</Option>;
                                    })}
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="AppKey">
                            {getFieldDecorator('key_id',{
                                rules:[
                                    {required:true,message:'Required'}
                                ]
                            })(
                                <Select
                                    showSearch
                                    style={{ width: 300 }}
                                    placeholder="Select AppKey"
                                    optionFilterProp="children"
                                >
                                    {this.state.keyList.map(item=>{
                                        return <Option key={item.id}>{item.api_key}</Option>;
                                    })}
                                </Select>
                            )}
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(abortAjaxHoc(BindApikey));



// WEBPACK FOOTER //
// ./src/pages/BindApikey/index.js